import type { OpenInterval } from "../open-interval";
import type { Time } from "../time";

import type { CombinedDateTimeFormatWithTime } from "./combined-date-time-format";
import { formatViewInterval } from "./format-view-interval";

export interface FormatIntervalOptions {
	/**
	 * TODO STAC-22104 make now required - USE RelativeTimeOptions
	 */
	now?: Time;
}

/**
 * Formats an interval using relative time formatting rules.
 *
 * If end is left undefined the `now` value will be used.
 */
export function formatInterval(
	interval: OpenInterval,
	{ now = new Date() }: FormatIntervalOptions = {},
): CombinedDateTimeFormatWithTime {
	return formatViewInterval({ interval, now, viewTime: now });
}
